'use client';

import {isServer} from '@rocket-ui/tools';
import {useEffect, useState} from 'react';

const getMatches = (query: string): boolean => {
	if (isServer) return false;

	return window.matchMedia(query).matches;
};

function subscribeToMediaChanges(query: string, handler: () => void) {
	const matchMedia = window.matchMedia(query);

	if (matchMedia.addListener) matchMedia.addListener(handler);
	else matchMedia.addEventListener('change', handler);

	return () => {
		if (matchMedia.removeListener) matchMedia.removeListener(handler);
		else matchMedia.removeEventListener('change', handler);
	};
}

export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState<boolean>(getMatches(query));

	useEffect(() => {
		const handleChange = () => setMatches(getMatches(query));

		handleChange();

		return subscribeToMediaChanges(query, handleChange);
	}, [query]);

	return matches;
}
